<template>
    <div class="PowerStatistics">
        <Title firstName="发电量统计" lastName="POWER GENERATION STATISTICS" />
        <div class="echarts">
            <!-- <div class="edata">
                <div class="edataCon">
                    <p>本月用电总量</p>
                    <p>{{sum || 21700}}<span> kWh</span></p>
                </div>
            </div> -->
            <div class="eview">
                <!-- <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" unit="kWh" v-if="seriesData.length > 0 && xData.length>0"/> -->
                <div class="noneData" >
                    光伏数据暂未接入
                </div>
            </div>
            <div class="state">
                <div class="item">
                    <div class="imgshow"><img src="@/assets/img/iconCo2.png" alt=""></div>
                    <div class="info">
                        <div class="title">碳减排</div>
                        <div class="num">--</div>
                    </div>
                </div>
                <div class="item">
                    <div class="imgshow"><img src="@/assets/img/economic2.png" alt=""></div>
                    <div class="info">
                        <div class="title">累计节约成本</div>
                        <div class="num">--</div>
                    </div>
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Title = () => import('../../../../components/title/Title')
const SelectList = () => import('../../../../components/title/selectList.vue')
const Bar = () => import('../../../../components/echarts/bar.vue')

import { getSevenDays, getMonthTime } from '../../../../utils/common/index'
export default {
    data(){
        return {
            chartId:'PowerStatistics2',
            xData:[],
            seriesData:[],
            total:''
        }
    },
    components:{
        Title,
        SelectList,
        Bar
    },
    computed:{
        sum(){
            let sum = 0
            this.seriesData.forEach(item =>{
                sum += item 
            })
            return sum.toFixed(2)
        }
    },
    created(){
        
        let time = getSevenDays()
        let timeArr = Object.values(time)

        let weekTime = []
        for(let i = 0;i <timeArr.length;i++){
            weekTime.unshift(timeArr[i].substr(5))
        }
        this.xData = weekTime
        this.seriesData = [2592, 1604, 3206, 3519, 3515, 3058, 1410]
    },
    methods:{
        // 获取本月该区域的用电统计 
        async getsiteElectricity(){
            let time = getMonthTime()
            // console.log(time);
            let data ={
                areaId:this.$store.state.siteId,
                start:`${time.start}T00:00:00Z`,
                end : `${time.end}T24:00:00Z`,
            }
            let res = await this.$http.PowerAnalysisArea(data)
            console.log(res);
            this.total =res.data.data.result.total? (res.data.data.result.total ).toFixed(2):0

        },
        // 获取近7日用电
        async getWeekElectricity(){
            let time = getSevenDays()
            let timeArr = Object.values(time)

            let weekTime = []
            for(let i = 0;i <timeArr.length;i++){
                weekTime.unshift(timeArr[i].substr(5))
            }
            this.xData = weekTime

            let arr = []
            for(let i = 0;i<timeArr.length;i++){
                let data = {
                    areaId:this.$store.state.siteId,
                    start:`${timeArr[i]}T00:00:00Z`,
                    end:`${timeArr[i]}T24:00:00Z`,
                }
                let res = await this.$http.diagramAreaDay(data)
                arr.unshift(res.data.data.data[0]?res.data.data.data[0] :0)
            }

            this.seriesData = arr

        },
    }
}
</script>

<style lang="less" scoped>
    
    .PowerStatistics{
        // height: 385.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            .state{
                padding: 0 1vw;
                display: flex;
                justify-content: space-around;
                font-size: 14rem;
                margin-top: 15rem;
                .imgshow{
                    width: 52rem;
                    height: 52rem;
                    border: 1px solid rgba(13,148,255,.3);
                    padding: 2rem;
                    text-align: center;
                    line-height: 52rem;
                    margin-right: 5rem;
                    img{
                        width: 100%;
                        height: 100%;
                        padding: 4rem 4rem;
                        background-color: rgba(13,148,255,.3);
                    }
                }
                    
                .item{
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    justify-content: space-between;
                    display: flex;
                    .num{
                        padding-top: 3rem;
                        font-size: 20rem;
                        color: #00DEFF;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0 1vh 0;
                position: relative;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
                
                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                width: 100%;
                padding: 2vh 0.5vw 0;
                box-sizing: border-box;
                height: 17vh;
                position: relative;
                #electCharts{
                    width: 100%;
                    height: 100%;
                }

                .noneData{
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    color: rgba(230,243,253, 0.7);
                    left: 50%;
                    transform: translate(-50% , -50%);
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>